import React from 'react';
import {Iog} from '../../../backend/model';
import {compareNumericString} from '../../../utils/sorting';
import {IogLink} from '../../TableItemLink';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';

const TABLE_ID = 'iapPage-iogsTable'

const COLUMN_DEFINITIONS = [
    {
        id: 'iogId',
        header: 'IOG',
        cell: (iog: Iog): JSX.Element => <IogLink iogId={iog.iogId}/>,
        sortingComparator: (a: Iog, b: Iog): number => compareNumericString(a.iogId, b.iogId),
        sortingField: 'iogId',
    },
    {
        id: 'iogName',
        header: 'Name',
        cell: (iog: Iog): string => iog.iogName,
        sortingField: 'iogName',
    },
]

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'IOG',
        key: 'iogId',
        groupValuesLabel: 'IOG ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Name',
        key: 'iogName',
        groupValuesLabel: 'Name values',
        operators: operators,
    },
]

const IogTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `Supplied by ${tableItems.length} IOGs`,
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.iogId, row.iogName]
        }
    }
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES)
}

export default IogTable
